<template>
    <v-card v-if="student" height="50" class="kimsa-elevation">
        <v-row>
            <v-col cols="3" class="py-0 pr-0">
                <div class="img-student" :style="{ backgroundImage: `url('${studentImg}')` }"/>
            </v-col>
            <v-col cols="9" class="text-caption">
                <div class="text-capitalize text-truncate">
                    {{ student.name || $t('common.not_available_short') }}
                </div>
                <div class="text-truncate" style="font-size: 10px">
                    {{ student.sportSelected || $t('common.not_available_short') }}
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: "MiniStudentCard",
    props: {
        student: {
            type: Object,
            default: null
        }
    },
    computed: {
        studentImg(vm = this) {
            return vm.student?.avatar || vm.imgPlaceholder
        }
    }
}
</script>

<style scoped>

.img-student {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: rgba(1, 55, 46, 0.07);
    height: 50px;
}

</style>